'use strict'

import { convertTime, specialCharsDecode } from '../../components/helpers.js'
import { getPreparedConfiguration, addConfigurableObjectProperties } from '../../components/ConfigurableObjectUtils.js'
import { getBrigadeName } from './RequestExecutorActions.js'
import { date } from 'quasar'
import FilesGroup from '../../components/File/FilesGroup.js'
import { isImageDocument } from '../../components/File/FileUtils.js'
import { axiosGet, axiosPost } from '../../axios/axios.js'
import Vue from 'vue'

export function convertRequestFromServer (requestFromServer, user) {
  const convertedRequest = {}

  convertedRequest.riAssignedBrigades = requestFromServer.riAssignedBrigades
  convertedRequest.autoAssigned = requestFromServer.autoAssigned
  convertedRequest.visId = requestFromServer.visId
  convertedRequest.complexHistory = requestFromServer.complexHistory
  convertedRequest.visComments = requestFromServer.visComments
  convertedRequest.state = requestFromServer.requestState
  convertedRequest._location = requestFromServer.location
  convertedRequest.requestLocation = requestFromServer.requestLocation
  convertedRequest.roadsLabels = requestFromServer.roadsLabels || []

  // ID задания.
  convertedRequest.bpContextId = requestFromServer.bpContextId || null

  // Статус БП.
  convertedRequest.bpStateId = requestFromServer.bpStateId || null
  convertedRequest.bpStateName = requestFromServer.bpStateName || null

  // Последний отчёт
  convertedRequest.reportId = requestFromServer.reportId || null
  convertedRequest.reportState = requestFromServer.reportState || null
  convertedRequest.reportStateName = requestFromServer.reportStateName || null

  // Объект обслуживания.
  convertedRequest.serviceObject = requestFromServer.serviceObject || null

  // Проект.
  convertedRequest.project = requestFromServer.project || null

  // Источник данных заявки.
  convertedRequest.requestSource = requestFromServer.requestSource

  // Источник, передавший заявку.
  convertedRequest.deliveryVIS = requestFromServer.deliveryVIS

  // Отказ ВИС в возвращении заявки в работу.
  convertedRequest.rejectReopen = !!requestFromServer.rejectReopen
  convertedRequest.rejectReopenDescription = requestFromServer.rejectReopenDescription || null
  convertedRequest.rejectReopenCancelDescription = requestFromServer.rejectReopenCancelDescription || null
  convertedRequest.rejectReopenBreakageRoads = requestFromServer.rejectReopenBreakageRoads || null
  convertedRequest.rejectReopenEquipmentStatusRoads = requestFromServer.rejectReopenEquipmentStatusRoads || null

  // Идентификатор заявки в ВИС.
  convertedRequest.requestVisId = requestFromServer.visId || null

  // ID заявки в боте.
  convertedRequest.cityMessengerBotRequestId = requestFromServer.cityMessengerBotRequestId || null

  // Идентификатор заявки в АС Дельта.
  convertedRequest.requestId = requestFromServer.id || null

  // Номер заявки в АС Дельта.
  convertedRequest.requestNumber = requestFromServer.requestNumber

  // Название заявки в АС Дельта.
  convertedRequest.name = requestFromServer.name

  // Адрес неисправности.
  convertedRequest.requestAddress = requestFromServer.requestAddress || null

  // Тип заявки.
  convertedRequest.requestTypeObject = requestFromServer.requestType || null

  // Тип неисправности
  convertedRequest.breakageTypeKey = requestFromServer.breakageTypeKey || null

  // Описание заявки.
  convertedRequest.applicantDescription = requestFromServer.applicantDescr ? specialCharsDecode(requestFromServer.applicantDescr) : ''

  // Время создания заявки.
  convertedRequest.createTime = requestFromServer.createTime || null

  // Время отложенного закрытия заявки в Roads
  convertedRequest.startCloseDateTime = requestFromServer.startCloseDateTime || null

  // Инициатор заявки.
  convertedRequest.initiator = requestFromServer.initiator && requestFromServer.initiator.length ? requestFromServer.initiator : null

  // Приоритет заявки.
  convertedRequest.requestPriority = requestFromServer.executionPriority || null

  // Приоритетность объекта.
  convertedRequest.serviceObjectPriority = requestFromServer.objectPriority || null // TODO

  // Особое условие.
  convertedRequest.priorityCondition = requestFromServer.priorityCondition ? requestFromServer.priorityCondition.id : null

  // Состав работ.
  convertedRequest.workTypes = requestFromServer.workTypes || []
  convertedRequest.workPackages = requestFromServer.workPackages || []

  /* Проверяем наличие технологических операций, у которых
  resultsRequired === true и required === false, и устанавливаем им required = true */
  bindTechnologicalOperationsRequiredFlags(convertedRequest.workTypes)
  convertedRequest.workPackages.forEach(wP => bindTechnologicalOperationsRequiredFlags(wP.workTypes))

  // Список направлений работ исполнителей.
  convertedRequest.assigneeWorkAreas = requestFromServer.assigneeWorkAreas

  // Состав работ подрядчика.
  convertedRequest.workTypesContractor = requestFromServer.workTypesContractor || []
  convertedRequest.workPackagesContractor = requestFromServer.workPackagesContractor || []

  /* Проверяем наличие технологических операций, у которых
  resultsRequired === true и required === false, и устанавливаем им required = true */
  bindTechnologicalOperationsRequiredFlags(convertedRequest.workTypesContractor)
  convertedRequest.workPackagesContractor.forEach(wP => bindTechnologicalOperationsRequiredFlags(wP.workTypes))

  // Состав работ для автоназначения.
  convertedRequest.autoAssignBrigadeWorkTypes = requestFromServer.autoAssignBrigadeWorkTypes || []
  convertedRequest.autoAssignBrigadeWorkPackages = requestFromServer.autoAssignBrigadeWorkPackages || []

  // Требуется приемка работ.
  convertedRequest.worksCheckRequired = !!requestFromServer.worksCheckRequired

  // Разрешено автоматическое назначение исполнителя.
  convertedRequest.autoAssign = !!requestFromServer.autoAssign

  // Начало активности автоназначения.
  convertedRequest.autoAssignStartTime = requestFromServer.autoAssignStartTime

  // Разрешение автоназначения для направления работ.
  convertedRequest.autoAssignWorkArea = !!requestFromServer.autoAssignWorkArea

  // Направления работ.
  convertedRequest.workAreas = requestFromServer.workAreas || []

  // Требуется автовышка.
  convertedRequest.forkliftTruckRequired = !!requestFromServer.forkliftTruckRequired

  // Требуемая автовышка.
  convertedRequest.requestForkliftTruck = requestFromServer.requestForkliftTruck || null

  // Усиление по текущему выезду на объект.
  convertedRequest.riAssignedBrigades = requestFromServer.riAssignedBrigades || []

  convertedRequest.assignedBrigade = requestFromServer.assignedBrigade || null
  convertedRequest.assignedEmployee = requestFromServer.assignedEmployee || null
  convertedRequest.assignedSystemUser = requestFromServer.assignedSystemUser || null

  // Документы.
  convertedRequest.documents = requestFromServer.documents
  // if (convertedRequest.documents) {
  //   convertedRequest.documents.sort((a, b) => b.time - a.time) // сначала новые -> серверная сортировка
  // }

  // Комментарии.
  convertedRequest.comments = requestFromServer.comments

  // Наименование в Roads.
  convertedRequest.externalName = requestFromServer.externalName || null

  // Ссылка в Roads.
  convertedRequest.externalUrl = requestFromServer.externalUrl || null

  // Время регистрации в Дельта 2.0.
  convertedRequest.registerTime = requestFromServer.registerTime || null

  // Время начала работ.
  convertedRequest.beginConditionTime = requestFromServer.beginConditionTime || null

  // Срок выполнения заявки.
  convertedRequest.closeConditionTimeText = 'Бессрочно'
  if (requestFromServer.closeConditionTime) {
    convertedRequest.closeConditionTime = requestFromServer.closeConditionTime
    convertedRequest.closeConditionTimeText = convertTime(requestFromServer.closeConditionTime).slice(0, -4)
  }

  // Активность заявки (в терминах фильтра "Активные заявки".
  convertedRequest.activeByState = requestFromServer.activeByState || null

  // Статус заявки в Roads.
  convertedRequest.statusVis = requestFromServer.statusVis || null

  // Ответственный исполнитель.
  convertedRequest.responsiblePerformer = requestFromServer.responsiblePerformer || null

  // Техническое задание.
  convertedRequest.technicalTasks = requestFromServer.technicalTasks || null
  // if (convertedRequest.technicalTasks) {
  //   convertedRequest.technicalTasks.sort((a, b) => b.time - a.time) // сначала новые -> серверная сортировка
  // }

  // Запрос на отзыв заявки.
  convertedRequest.withdrawRequest = !!requestFromServer.withdrawRequest

  // Требуется дополнительный выезд.
  convertedRequest.additionalDepartureRequired = !!requestFromServer.additionalDepartureRequired

  // Ожидается дополнительный выезд.
  convertedRequest.additionalDepartureExpected = !!requestFromServer.additionalDepartureExpected

  // Требуется перевод на другого исполнителя.
  convertedRequest.requiredAnotherPerformerTranslation = requestFromServer.requiredAnotherPerformerTranslation

  // Признак установленного в БД значения "Требуется перевод на другого исполнителя"
  convertedRequest.isRequiredAnotherPerformerTranslationDBSet = requestFromServer.requiredAnotherPerformerTranslation != null

  // Заявка открыта повторно.
  convertedRequest.reopened = !!requestFromServer.reopened

  // Причина повторного открытия заявки.
  convertedRequest.reopeningReason = requestFromServer.reopeningReason || null

  // Группа заданий.
  convertedRequest.group = requestFromServer.group

  convertedRequest.proposedExecutorObject = null
  convertedRequest.proposedReinforcementExecutorObject = null
  convertedRequest.imagesToUpload = [] // TODO
  convertedRequest.filesToUpload = []

  // Контроль статуса в ВИС.
  convertedRequest.visStatusControl = requestFromServer.visStatusControl

  // Направление работ для перевода заявки на другой отдел.
  convertedRequest.redirectedWorkAreaKey = requestFromServer.redirectedWorkAreaKey || null
  convertedRequest.redirectedWorkAreaName = requestFromServer.redirectedWorkArea || null

  // Недавние заявки с объекта обслуживания
  convertedRequest.serviceObjectRecentRequests = requestFromServer.serviceObjectRecentRequests || []
  // Заявки с объекта обслуживания, близкие по времени создания к текущей заявке
  convertedRequest.closeRequests = requestFromServer.closeRequests || []

  // Заявки-инициаторы
  convertedRequest.initiatorRequests = requestFromServer.initiatorRequests || []
  // Инициируемые заявки
  convertedRequest.initiatedRequests = requestFromServer.initiatedRequests || []

  // Синхронизирующая заявка
  convertedRequest.synchronizeSourceRequest = requestFromServer.synchronizeSourceRequest || null
  // Синхронизируемая заявка
  convertedRequest.synchronizeTargetRequest = requestFromServer.synchronizeTargetRequest || null

  // Признак аудит
  convertedRequest.audit = requestFromServer.audit
  convertedRequest.auditObject = requestFromServer.auditObject

  convertedRequest.auditRemarksDocuments = requestFromServer.auditRemarksDocuments
  convertedRequest.auditRemarks = requestFromServer.auditRemarks
  convertedRequest.showAuditRemarks = requestFromServer.showAuditRemarks

  // НШС
  convertedRequest.alarms = requestFromServer.alarms || []

  // Замечания к объекту обслуживания
  convertedRequest.maintenanceNotes = requestFromServer.maintenanceNotes || []

  convertedRequest.actionsProps = requestFromServer.actionsProps

  // Заявка Roads
  convertedRequest.requestRoads = requestFromServer.roadsRequestData // Данные в roads по этой заявке
  convertedRequest.roadsRequestCommandId = requestFromServer.roadsRequestCommandId // Id сохраненного вызова команды roads

  // Интеграция с Roads
  convertedRequest.unableToCreateRequestInRoadsReasons = requestFromServer.unableToCreateRequestInRoadsReasons
  convertedRequest.needExportToRoads = requestFromServer.needExportToRoads
  convertedRequest.autoAcceptedToWorkRoads = requestFromServer.autoAcceptedToWorkRoads
  convertedRequest.exportImportStatus = requestFromServer.exportImportStatus
  convertedRequest.integrationLog = requestFromServer.integrationLog || []
  convertedRequest.visUpdateTime = requestFromServer.visUpdateTime
  convertedRequest.changeTimeCheck = requestFromServer.changeTimeCheck

  // Данные по объекту обслуживания
  convertedRequest.zabbixMonitoringStatus = requestFromServer.zabbixMonitoringStatus || null

  // Наличие активных заявок на смежных объектах
  convertedRequest.hasAdjacentRequest = !!requestFromServer.hasAdjacentRequest

  // Наличие несданного отчета
  convertedRequest.hasNotReadyReport = !!requestFromServer.hasNotReadyReport

  // Запретить ручное назначение
  convertedRequest.forbiddenManualAssign = !!requestFromServer.forbiddenManualAssign

  // Разрешено принять к исполнению (если false, то разрешено выполнять заявки только в порядке очереди)
  convertedRequest.acceptForExecutionAllowed = !!requestFromServer.acceptForExecutionAllowed

  // Изменения данных задачи ПТК АПТС
  convertedRequest.supTaskData = requestFromServer.supTaskData || null
  convertedRequest.supRequestActualization = requestFromServer.supRequestActualization || null
  convertedRequest.supTaskChangedNotify = requestFromServer.supTaskChangedNotify === true

  addRequestProperties(convertedRequest, requestFromServer.configuration, user)

  for (const fieldConfig of convertedRequest._configuration.configurableFields) {
    if (fieldConfig.additional) {
      let value = requestFromServer[fieldConfig.key]
      if (value == null) {
        value = null
      }
      convertedRequest[fieldConfig.key] = value
    }
  }

  if (convertedRequest.hasAdditionalField('yandexExecutors')) {
    convertedRequest.yandexExecutor = requestFromServer.yandexExecutor || null

    const yandexExecutorJournalRecords = requestFromServer.yandexExecutorJournalRecords || []
    for (const record of yandexExecutorJournalRecords) {
      record._userAssigned = record.useState && record.useState.id === 'userAssigned'
    }
    convertedRequest.yandexExecutorJournalRecords = yandexExecutorJournalRecords
    convertedRequest.yandexTasks = requestFromServer.yandexTasks || []
  }

  convertedRequest.beaconMountingPointZoneIds = requestFromServer.zoneExternalIds || null

  return convertedRequest
}

export function createRequestWithDefaultFields (user) {
  const request = {
    bpStateId: 'BS0',
    bpStateName: null,
    reportState: null,
    reportStateName: null,
    requestSource: null, // Источник данных заявки.
    deliveryVIS: null, // Источник передавший заявку.
    rejectReopen: false, // Отказ ВИС в возвращении заявки в работу.
    rejectReopenDescription: null, // Причина отказа ВИС в возвращении заявки в работу.
    rejectReopenCancelDescription: null, // Причина отмены отказа ВИС в возвращении заявки в работу.
    rejectReopenBreakageRoads: null, // Тип неисправности в Roads.
    rejectReopenEquipmentStatusRoads: null, // Состояние оборудования после выполнения работ.
    requestVisId: null, // ID заявки в боте.
    cityMessengerBotRequestId: null, // Идентификатор заявки в ВИС.
    requestId: null, // Идентификатор заявки в АС Дельта.
    serviceObject: null, // Объект обслуживания
    project: null, // Проект
    _location: null,
    requestLocation: null,
    requestAddress: null, // Адрес неисправности.
    requestTypeObject: null, // Тип заявки.
    requestsTypes: null, // Подходящие типы заявок.
    applicantDescription: '', // Описание заявки от Заявителя.
    createTime: null, // Дата/время создания заявки.
    initiator: null, // Инициатор заявки.
    requestPriority: null, // Приоритет заявки.
    serviceObjectPriority: null, // Приоритетность объекта.
    priorityCondition: null, // Особое условие.
    workTypes: [], // Состав работ.
    workTypesContractor: [], // Состав работ.
    workPackages: [],
    workPackagesContractor: [], // Состав работ.
    assigneeWorkAreas: [],
    executorWorkAreas: [],
    autoAssignBrigadeWorkTypes: [],
    autoAssignBrigadeWorkPackages: [],
    worksCheckRequired: false,
    autoAssign: false, // Разрешено автоматическое назначение исполнителя.
    autoAssignStartTime: null,
    forkliftTruckRequired: false,
    requestForkliftTruck: null,
    documents: [], // Документы.
    imagesToUpload: [], // TODO
    filesToUpload: [],
    proposedExecutorObject: null,
    proposedReinforcementExecutorObject: null,
    serviceObjectRecentRequests: null,
    closeRequests: null,
    redirectedWorkAreaKey: null,
    requestToAudit: null,
    requestsToAudit: null,
    initiatorRequests: [],
    initiatedRequests: [],
    comments: []
  }
  addRequestProperties(request, null, user)
  return request
}

export function addRequestProperties (request, requestConfiguration, user) {
  // Расширенное название заявки в формате Roads
  Object.defineProperty(request, 'nameExtended', {
    get: function () {
      if (this.name) {
        let millis = this.registerTime
        if (!millis && !this.visId) {
          millis = this.createTime // Для внутренней заявки registerTime, если оно есть, совпадает с createTime
        }
        if (millis) {
          const dateText = date.formatDate(millis, 'DD.MM.YYYY')
          const timeText = date.formatDate(millis, 'HH:mm:ss')
          return `${this.name} от ${dateText} г. (${timeText})`
        }
        return this.name
      }
      return ''
    }
  })
  // Id источника данных заявки.
  Object.defineProperty(request, 'requestSourceId', {
    get: function () {
      return (this.requestSource && this.requestSource.id) || null
    }
  })
  /*
   * Объект обслуживания
   */
  // ID объекта.
  Object.defineProperty(request, 'serviceObjectId', {
    get: function () {
      return this.serviceObject ? this.serviceObject.id : null
    }
  })
  // Key объекта.
  Object.defineProperty(request, 'serviceObjectKey', {
    get: function () {
      return this.serviceObject ? this.serviceObject.key : null
    }
  })
  // Ключ типа объекта.
  Object.defineProperty(request, 'serviceObjectType', {
    get: function () {
      if (this.serviceObject && this.serviceObject.type) {
        if (typeof this.serviceObject.type === 'object') {
          return this.serviceObject.type.key
        } else {
          return this.serviceObject.type
        }
      }
      return null
    }
  })
  // Название объекта.
  Object.defineProperty(request, 'serviceObjectName', {
    get: function () {
      return this.serviceObject ? this.serviceObject.alias || this.serviceObject.name : null
    }
  })
  // Адрес объекта.
  Object.defineProperty(request, 'serviceObjectAddress', {
    get: function () {
      return this.serviceObject ? this.serviceObject.address || this.serviceObject.addressSummary || null : null
    }
  })
  // Координаты объекта.
  Object.defineProperty(request, 'serviceObjectLocation', {
    get: function () {
      return this.serviceObject ? this.serviceObject.location || null : null
    }
  })

  // Object.defineProperty(request, 'serviceObjectTypeObj', {
  //   get: function () {
  //     if (this.serviceObject && this.serviceObject.type && typeof this.serviceObject.type === 'object') {
  //       return this.serviceObject.type
  //     }
  //     return null
  //   }
  // })

  /**
   * Координаты неисправности
   */
  Object.defineProperty(request, 'location', {
    get: function () {
      return this._location || this.requestLocation || null
    },
    set: function (value) {
      if (value) {
        this._location = value
      } else {
        this._location = this.requestLocation || null // Исходные координаты из ВИС
      }
    }
  })

  /*
   * Тип заявки
   */
  Object.defineProperty(request, 'requestType', { // TODO refactor -> requestTypeId
    get: function () {
      return this.requestTypeObject ? this.requestTypeObject.id : null
    }
  })
  Object.defineProperty(request, 'requestTypeId', {
    get: function () {
      return this.requestTypeObject ? this.requestTypeObject.id : null
    }
  })
  Object.defineProperty(request, 'requestTypeKey', {
    get: function () {
      return this.requestTypeObject ? this.requestTypeObject.key : null
    }
  })
  Object.defineProperty(request, 'requestTypeName', {
    get: function () {
      return this.requestTypeObject ? this.requestTypeObject.name : null
    }
  })

  Object.defineProperty(request, 'hasAutoAssignSettings', {
    get: function () {
      return this.autoAssignBrigadeWorkTypes.length || this.autoAssignBrigadeWorkPackages.length
    }
  })

  Object.defineProperty(request, 'hasProposedExecutor', {
    get: function () {
      return this.proposedExecutorObject != null || this.proposedReinforcementExecutorObject != null
    }
  })

  Object.defineProperty(request, 'hasAssignedExecutor', {
    get: function () {
      return !!(this.assignedBrigade || this.assignedEmployee || this.assignedSystemUser)
    }
  })

  // Исполнитель по текущему выезду на объект
  Object.defineProperty(request, 'executorName', {
    get: function () {
      let executorName = null
      if (this.proposedExecutorObject == null) {
        if (this.assignedBrigade) {
          executorName = getBrigadeName(this.assignedBrigade)
        } else if (this.assignedEmployee) {
          executorName = this.assignedEmployee.fio
        } else if (this.assignedSystemUser) {
          executorName = this.assignedSystemUser.fio
        }
      } else {
        if (this.proposedExecutorObject.type === 'brigade') {
          executorName = getBrigadeName(this.proposedExecutorObject.executor)
        } else {
          executorName = this.proposedExecutorObject.name
        }
      }
      return executorName
    }
  })

  Object.defineProperty(request, 'reinforcementExecutorsNames', {
    get: function () {
      let value = null
      const object = this.proposedReinforcementExecutorObject
      if (object == null || object.executors.length === 0) {
        if (object == null && !!this.riAssignedBrigades && this.riAssignedBrigades.length) {
          value = this.riAssignedBrigades.map(br => getBrigadeName(br)).join(', ')
        } else {
          value = null
        }
      } else {
        value = object.executors.map(br => getBrigadeName(br)).join(', ')
      }
      // if (this.riAssignedBrigades.length) {
      //   return this.riAssignedBrigades.map(br => getBrigadeName(br)).join(', ')
      // }
      return value
    }
  })

  request.filterWorkTypes = function (allWorkTypes, isAudit, workAreasKeys) {
    const request = this
    let filteredWorkTypes
    if (isAudit) {
      filteredWorkTypes = allWorkTypes.filter(workType => workType.isAudit)
    } else {
      const serviceObjectTypeKey = request.serviceObjectType
      const requestType = request.requestTypeObject
      if (serviceObjectTypeKey) {
        filteredWorkTypes = allWorkTypes.filter(workType => {
          if (workType.serviceObjectTypes.length === 0) { // Работа соответствует любому типу объекта
            return matchWorkTypeToRequestTypeByWorkAreas(workType, requestType)
          }
          return workType.serviceObjectTypes.includes(serviceObjectTypeKey)
        })
      } else {
        if (requestType && requestType.serviceObjectType && requestType.serviceObjectType.length) {
          const types = requestType.serviceObjectType.map(o => o.key)
          filteredWorkTypes = allWorkTypes.filter(workType => {
            if (workType.serviceObjectTypes.length === 0) {
              return true // Работа соответствует любому типу объекта
            }
            for (let i = 0; i < types.length; i++) {
              if (workType.serviceObjectTypes.includes(types[i])) {
                return true
              }
            }
            return false
          })
        } else if (requestType) {
          filteredWorkTypes = allWorkTypes.filter(workType => {
            if (workType.serviceObjectTypes.length === 0) { // Работа соответствует любому типу объекта
              return matchWorkTypeToRequestTypeByWorkAreas(workType, requestType)
            }
            return false
          })
        } else if (workAreasKeys && workAreasKeys.length) {
          filteredWorkTypes = allWorkTypes.filter(workType => {
            if (workType.workAreas && workType.workAreas.length) {
              for (const workAreaKey of workType.workAreas) {
                if (workAreasKeys.includes(workAreaKey)) {
                  return true
                }
              }
              return false
            } else {
              return true // TODO соответствует любому направлению ???
            }
          })
        } else {
          filteredWorkTypes = allWorkTypes.slice()
        }
      }
    }
    return filteredWorkTypes || []
  }

  request.filesGroupsMap = createFilesGroupsMap(request, false)

  Object.defineProperty(request, 'isCreationState', {
    get: function () {
      return !!(this.bpStateId === 'BS0')
    }
  })

  Object.defineProperty(request, 'isRoadsIntegrationAvailable', {
    get: function () {
      return !this.supTaskData
    }
  })
  Object.defineProperty(request, 'isMgtIntegrationAvailable', {
    get: function () {
      return !!this.supTaskData
    }
  })

  // Отказ ВИС в возвращении заявки в работу доступен только для внешних заявок
  // по направлению работ СО, переданных Ситуационным центром ЦОДД (Roads).
  Object.defineProperty(request, 'isRejectReopenAvailable', {
    get: function () {
      return this.isRoadsIntegrationAvailable &&
        !!this.requestVisId &&
        !!(this.workAreas || []).find(workArea => workArea && (workArea.key === 'SO' || workArea.id === 'SO')) &&
        !!(this.deliveryVIS && this.deliveryVIS.key === 'roadsmsk')
    }
  })

  addConfigurableRequestProperties(request, requestConfiguration, user)
}

function matchWorkTypeToRequestTypeByWorkAreas (workType, requestType) {
  if (requestType && requestType.workAreas && workType.workAreas) {
    for (const workAreaKey of requestType.workAreas) {
      if (workType.workAreas.includes(workAreaKey)) {
        return true
      }
    }
    return false
  }
  return true
}

export function createFilesGroupsMap (request, requestFilesReadonly) {
  const filesGroupSourceConfig = {
    get objectId () {
      return request.requestId
    },
    uploadURL: '/service/delta/document/upload',
    removeURL: '/service/delta/document/deleteFromObject'
  }

  const filesGroups = [
    new FilesGroup({
      key: 'images',
      categoryKey: 'dispatcher',
      readonly: requestFilesReadonly,
      sourceConfig: filesGroupSourceConfig,
      enrichmentFn: function (document) {
        return {
          name: request.name + '-' + this.files.length + '.' + document.contentType.split('/')[1] // TODO FileDocument - name
        }
      }
    }),
    new FilesGroup({
      key: 'docFiles',
      categoryKey: 'files',
      readonly: requestFilesReadonly,
      sourceConfig: filesGroupSourceConfig
    }),
    new FilesGroup({
      key: 'technicalTasks',
      readonly: true
    })
  ]

  const filesGroupsMap = Object.fromEntries(Object.values(filesGroups).map(filesGroup => [filesGroup.key, filesGroup]))

  if (request.documents) {
    request.documents.forEach(document => {
      if (document.category !== 'files' && isImageDocument(document)) {
        filesGroupsMap.images.pushFile(document)
      } else if (document.category === 'files' || !isImageDocument(document)) {
        filesGroupsMap.docFiles.pushFile(document)
      }
    })
  }
  if (request.technicalTasks) {
    filesGroupsMap.technicalTasks.pushFiles(request.technicalTasks)
  }
  return filesGroupsMap
}

export function bindTechnologicalOperationsRequiredFlags (workTypes) {
  for (const workType of workTypes) {
    if (workType.technologicalOperations && workType.technologicalOperations.length) {
      for (const operation of workType.technologicalOperations) {
        if (operation.resultsRequired && !operation.required) {
          Vue.set(operation, 'required', true)
        }
      }
    }
  }
}

export function convertRequestToServer (requestToServer, isInitialize, requestInitial = null) {
  const convertedRequest = {}

  // Источник данных заявки.
  convertedRequest.requestSource = requestToServer.requestSourceId
  convertedRequest.deliveryVIS = requestToServer.deliveryVIS ? requestToServer.deliveryVIS.id : null

  // Объект обслуживания (Key объекта).
  if (requestToServer.isFieldIncluded('serviceObject')) {
    convertedRequest.serviceObjectId = requestToServer.serviceObjectKey
  }

  // Адрес объекта.
  if (requestToServer.isFieldIncluded('address')) {
    convertedRequest.address = requestToServer.serviceObjectAddress
  }

  // Проект.
  if (requestToServer.isFieldIncluded('project') && requestToServer.project) {
    convertedRequest.project = requestToServer.project
  }

  // Отказ ВИС в возвращении заявки в работу.
  if (requestToServer.isRejectReopenAvailable) {
    convertedRequest.rejectReopen = !!requestToServer.rejectReopen
    if (requestToServer.rejectReopen) {
      convertedRequest.rejectReopenDescription = requestToServer.rejectReopenDescription
      convertedRequest.rejectReopenBreakageRoads = requestToServer.rejectReopenBreakageRoads
      convertedRequest.rejectReopenEquipmentStatusRoads = requestToServer.rejectReopenEquipmentStatusRoads
      if (requestInitial && !requestInitial.rejectReopen) {
        convertedRequest.rejectReopenCancelDescription = null
      }
    } else {
      convertedRequest.rejectReopenDescription = null
      convertedRequest.rejectReopenBreakageRoads = null
      convertedRequest.rejectReopenEquipmentStatusRoads = null
    }
  }

  // Координаты неисправности.
  if (requestToServer.isFieldIncluded('location')) {
    convertedRequest.location = requestToServer.location
  }

  // Адрес неисправности.
  if (requestToServer.isFieldIncluded('requestAddress')) {
    convertedRequest.requestAddress = requestToServer.requestAddress
  }

  // Тип заявки.
  convertedRequest.requestType = Number(requestToServer.requestType)

  // Тип неисправности
  convertedRequest.breakageTypeKey = requestToServer.breakageTypeKey

  // Описание заявки от заявителя.
  convertedRequest.applicantDescr = requestToServer.applicantDescription

  // Приоритет заявки.
  convertedRequest.executionPriority = Number(requestToServer.requestPriority)

  // Приоритетность объекта.
  if (requestToServer.isFieldIncluded('serviceObjectPriority') && Number(requestToServer.serviceObjectPriority) != 0) {
    convertedRequest.objectPriority = Number(requestToServer.serviceObjectPriority)
  }

  // Особое условие.
  if (requestToServer.isFieldIncluded('priorityCondition') && requestToServer.priorityCondition != null) {
    convertedRequest.priorityCondition = Number(requestToServer.priorityCondition)
  }

  // Работы.
  // Состав работ.
  // TODO [{ id, done, comment, technologicalOperations }, ...] - см. AbstractRequestEntity.setWorkTypesOperations(...)
  if (requestInitial && (
    JSON.stringify(requestToServer.workTypes) !== JSON.stringify(requestInitial.workTypes) ||
    JSON.stringify(requestToServer.workPackages) !== JSON.stringify(requestInitial.workPackages)
  ) || !requestInitial) {
    convertedRequest.workTypes = requestToServer.workTypes ? requestToServer.workTypes.slice() : []
    convertedRequest.workPackages = requestToServer.workPackages ? requestToServer.workPackages.slice() : []
  }
  // Комплексы работ

  // Работы подрядчика.
  if (requestToServer.isFieldIncluded('worksContractorBlock')) {
    if (requestInitial && (
      JSON.stringify(requestToServer.workTypesContractor) !== JSON.stringify(requestInitial.workTypesContractor) ||
    JSON.stringify(requestToServer.workPackagesContractor) !== JSON.stringify(requestInitial.workPackagesContractor)
    ) || !requestInitial) {
    // Состав работ подрядчика.
      convertedRequest.workTypesContractor = requestToServer.workTypesContractor ? requestToServer.workTypesContractor.slice() : []
      // Комплексы работ
      convertedRequest.workPackagesContractor = requestToServer.workPackagesContractor ? requestToServer.workPackagesContractor.slice() : []
    }
  }

  // Состав работ для автоназначения.
  if (requestToServer.isFieldIncluded('autoAssignBlock')) {
    if (requestInitial && (
      JSON.stringify(requestToServer.autoAssignBrigadeWorkTypes) !== JSON.stringify(requestInitial.autoAssignBrigadeWorkTypes) ||
    JSON.stringify(requestToServer.autoAssignBrigadeWorkPackages) !== JSON.stringify(requestInitial.autoAssignBrigadeWorkPackages)
    ) || !requestInitial) {
      if (requestToServer.autoAssignBrigadeWorkTypes) {
        convertedRequest.requestAutoAssignBrigadeWorkType = requestToServer.autoAssignBrigadeWorkTypes.map(o => o.id)
      }
      if (requestToServer.autoAssignBrigadeWorkPackages) {
        convertedRequest.requestAutoAssignBrigadeWorkPackage = requestToServer.autoAssignBrigadeWorkPackages.map(o => o.id)
      }
    }
  }

  // Требуется приемка работ.
  if (requestToServer.isFieldIncluded('worksCheckRequired')) {
    convertedRequest.worksCheckRequired = !!requestToServer.worksCheckRequired
  }

  // Требуется перевод на другого исполнителя
  convertedRequest.requiredAnotherPerformerTranslation = requestToServer.requiredAnotherPerformerTranslation

  if (requestToServer.isFieldIncluded('autoAssignBlock')) {
    // Разрешено автоматическое назначение исполнителя.
    convertedRequest.autoAssign = !!requestToServer.autoAssign

    // Начало активности автоназначения.
    convertedRequest.autoAssignStartTime = requestToServer.autoAssignStartTime
  }

  // Требуется автовышка.
  if (requestToServer.isFieldIncluded('forkliftTruckRequired')) {
    convertedRequest.forkliftTruckRequired = !!requestToServer.forkliftTruckRequired
  }

  // Требуемая автовышка.
  if (requestToServer.isFieldIncluded('requestForkliftTruck')) {
    convertedRequest.requestForkliftTruck = convertedRequest.forkliftTruckRequired && requestToServer.requestForkliftTruck != null ? requestToServer.requestForkliftTruck.id : null
  }

  // Комментарии.
  convertedRequest.comments = requestToServer.comments
    .filter(comment => comment.added)
    .map(data => {
      return { comment: data.comment }
    })

  // Контроль статуса в ВИС.
  convertedRequest.visStatusControl = !!requestToServer.visStatusControl

  // Направление работ для перевода заявки на другой отдел.
  if (requestToServer.isFieldIncluded('redirectedWorkArea')) {
    convertedRequest.redirectedWorkArea = requestToServer.redirectedWorkAreaKey || null
  }

  // Заявка, на которую аудит
  if (requestToServer.requestToAudit) {
    convertedRequest.requestToAudit = requestToServer.requestToAudit
  }
  // Объекты, на которые аудит
  if (requestToServer.objectsToAudit) {
    convertedRequest.objectsToAudit = requestToServer.objectsToAudit
  }

  // Срок выполнения.
  convertedRequest.closeConditionTime = requestToServer.closeConditionTime

  // Заявки-инициаторы
  convertedRequest.initiatorRequests = requestToServer.initiatorRequests
  // Инициируемые заявки
  convertedRequest.initiatedRequests = requestToServer.initiatedRequests

  // Заявка, состояние которой будет синхронизироваться с состоянием текущей заявки
  convertedRequest.synchronizeTargetRequest = requestToServer.synchronizeTargetRequest

  if (requestToServer._configuration.configurableFields.length) {
    for (const fieldConfig of requestToServer._configuration.configurableFields) {
      if (fieldConfig.additional && fieldConfig.computed === false) {
        convertedRequest[fieldConfig.key] = requestToServer[fieldConfig.key]
      }
    }
  }

  if (isInitialize) {
    const documents = []
    const filesGroupsMap = requestToServer.filesGroupsMap
    for (const fileWrapper of filesGroupsMap.images.files) {
      documents.push({
        id: fileWrapper.document.id,
        category: 'dispatcher'
      })
    }
    for (const fileWrapper of filesGroupsMap.docFiles.files) {
      documents.push({
        id: fileWrapper.document.id,
        category: 'files'
      })
    }

    convertedRequest.document = documents
  }

  return convertedRequest
}

export const REQUEST_PRIORITIES = [
  { name: '1 (Низкий)', value: 6 },
  { name: '5 (Низкий)', value: 7 },
  { name: '10 (Низкий)', value: 8 },
  { name: '15 (Средний)', value: 9 },
  { name: '20 (Средний)', value: 10 },
  { name: '25 (Средний)', value: 11 },
  { name: '30 (Средний)', value: 12 },
  { name: '35 (Средний)', value: 13 },
  { name: '40 (Высокий)', value: 14 },
  { name: '45 (Высокий)', value: 15 },
  { name: '50 (Высокий)', value: 16 },
  { name: '55 (Высокий)', value: 17 },
  { name: '60 (Высокий)', value: 18 },
  { name: '65 (Высокий)', value: 19 },
  { name: '70 (Срочно)', value: 20 },
  { name: '75 (Срочно)', value: 21 },
  { name: '80 (Срочно)', value: 22 },
  { name: '85 (Срочно)', value: 23 },
  { name: '90 (Критический)', value: 24 },
  { name: '92.5 (Критический)', value: 25 },
  { name: '95 (Критический)', value: 26 },
  { name: '97.5 (Критический)', value: 27 },
  { name: '100 (Критический)', value: 28 }
]

export const REQUEST_TEMPLATES = {
  DtBatteries: {
    requestType: 'Замена АКБ (ДТ)',
    autoAssign: true
  }
}

export const ADDITIONAL_FIELDS_CONFIGURATIONS = {
  // вычисляемые => НЕ отправлять на сервер
  complexAddress: {
    type: 'string',
    computed: true
  },
  facePayCamerasCount: {
    type: 'number',
    computed: true
  },
  commonCamerasCount: {
    type: 'number',
    computed: true
  },
  commonCameras1Count: {
    type: 'number',
    computed: true
  },
  yandexExecutors: {
    type: 'string',
    computed: true
  },
  yandexExecutor: {
    type: 'string',
    computed: true
  },
  yandexExecutorJournalRecords: {
    type: 'string',
    computed: true
  },
  // невычисляемые => отправлять на сервер
  rendezvousControlTime: {
    type: 'number',
    computed: false
  },
  rendezvousControlPlace: {
    type: 'string',
    computed: false
  },
  controlContacts: {
    type: 'string',
    computed: false
  },
  controlInfo: {
    type: 'string',
    computed: false
  },
  remontPositionId: {
    type: 'string',
    computed: false
  },
  remontPositionName: {
    type: 'string',
    computed: false
  }
}

// const EXCLUDABLE_FIELDS = new Set([
//   'requestAddress',
//   'requestLocation', // ?
//   'location',
//   'forkliftTruckRequired',
//   'requestForkliftTruck'
// ])

export function getRequestRoles (request, user, formId) {
  const roles = user.roles || {}
  const roleAdminOrRoot = (!!roles.root || !!roles.admin) && (!request.actionsProps || !!request.actionsProps.hasDispatcherAccess)
  const roleDispatcherOrHigher = request.actionsProps ? !!request.actionsProps.hasDispatcherAccess : !!roles.root || !!roles.admin || !!roles.dispatcher || formId === 'createRequestCard'
  const roleAuditorOrHigher = !!roles.root || !!roles.admin || !!roles.auditor
  const roleReportCheckerOrHigher = !!roles.root || !!roles.admin || !!roles.reportchecker
  const roleContractorDispatcher = !!(!!roles.contractorDispatcher && (!!request.assignedBrigade && !!request.assignedBrigade.contractor || !!request.assignedEmployee && !!request.assignedEmployee.contractor))
  const hasRoleEmployee = user.hasRoleStrict('brigadier', 'officeemployee', 'brigademember', 'contractorOfficeemployee')
  const roleEmployee = hasRoleEmployee && !roleAdminOrRoot && !roleDispatcherOrHigher && !roleReportCheckerOrHigher && !roleContractorDispatcher
  const roleExternalDispatcher = !!(user.employee && user.employee.external && (user.hasRoleStrict('dispatcher') || user.hasRoleStrict('externalDispatcher')))
  const roleExternalDispatcherBounded = roleExternalDispatcher && (user.hasRoleStrict('externalDispatcher') && !user.hasRoleStrict('dispatcher'))
  let roleExecutor

  if (user.employee) {
    let isBrigadeEmployee = false
    const userEmployeeId = user.employee.id

    if (roles.brigadier && request.assignedBrigade) {
      const brigadeEmployees = request.assignedBrigade.employees

      const executorEmployee = brigadeEmployees.find(employee => {
        return employee.id === userEmployeeId
      })

      if (executorEmployee) {
        isBrigadeEmployee = true
      }
    }

    roleExecutor = isBrigadeEmployee || !!((!!roles.officeemployee || !!roles.contractorOfficeemployee || roleDispatcherOrHigher) && !!request.assignedEmployee && request.assignedEmployee.login === user.login) // TODO
  }

  const noEditStatuses = new Set(['BS17', 'BS12', 'BS18', 'BS20', 'BS8', 'BS11', 'BS9', 'BS19', 'BS21'])
  const editAvailable = !noEditStatuses.has(request.bpStateId) && !user.externalCurator // TODO

  const isContractorDispatcher = !user.roles.root && user.hasRole('contractorDispatcher') // user.roles.contractorDispatcher
  const roleRestrictedDispatcher = !!user.restrictedAccess

  const isLastReportDeferred = request.reportState === 'PR11'

  const requestRoles = {
    roles: roles,
    roleAdminOrRoot: roleAdminOrRoot,
    roleDispatcherOrHigher: roleDispatcherOrHigher,
    roleReportCheckerOrHigher: roleReportCheckerOrHigher,
    roleContractorDispatcher: roleContractorDispatcher,
    roleExternalDispatcher: roleExternalDispatcher,
    roleExternalDispatcherBounded: roleExternalDispatcherBounded,
    roleRestrictedDispatcher: roleRestrictedDispatcher,
    roleRestrictedOrExternalDispatcher: roleExternalDispatcher || roleRestrictedDispatcher,
    roleAuditorOrHigher: roleAuditorOrHigher,
    roleEmployee: roleEmployee,
    roleExecutor: roleExecutor,
    editAvailable: editAvailable,
    isContractor: user.isContractor,
    get executorChangeAvailableByContractor () {
      if (isContractorDispatcher && !isLastReportDeferred) {
        return !!request &&
          (
            !!request.actionsProps.contractorAssignmentAccess ||
            ((
              request.bpStateId === 'BS8' && !!request.actionsProps.BS10_contractorDispatcher ||
              request.bpStateId === 'BS10' && !!request.actionsProps.BS03_contractorDispatcher
            ) &&
            (formId == 'popup' ? request.bpStateId === 'BS10' : true)) // TODO
          )
      }
      return false
    },
    get executorChangeAvailable () {
      if (isContractorDispatcher) {
        return this.executorChangeAvailableByContractor
      }

      const restrictedExternalUser = user.restrictedAccess && user.employee && user.employee.external // TODO operation assignExecutor

      if (this.roleDispatcherOrHigher && !restrictedExternalUser &&
        !isLastReportDeferred &&
        (
          request.bpStateId === 'BS0' ||
          request.bpStateId === 'BS1' ||
          request.bpStateId === 'BS2' ||
          request.bpStateId === 'BS3' ||
          request.bpStateId === 'BS4' ||
          request.bpStateId === 'BS8' ||
          request.bpStateId === 'BS10' ||
          request.bpStateId === 'BS13'
        )
      ) {
        const performRequestRoles = request._configuration && request._configuration.performeRequestRole || []
        if (performRequestRoles.length) {
          return user.hasRole('admin') || user.hasRole(...performRequestRoles)
        } else {
          return true
        }
      }
      return false
    },
    get reinforcementExecutorChangeAvailable () {
      return this.roleDispatcherOrHigher &&
        !isLastReportDeferred &&
        (
          request.bpStateId === 'BS0' ||
          request.bpStateId === 'BS1' ||
          request.bpStateId === 'BS2' ||
          request.bpStateId === 'BS3' ||
          request.bpStateId === 'BS4' ||
          request.bpStateId === 'BS5' || // отличие от executorChangeAvailable
          request.bpStateId === 'BS8' ||
          request.bpStateId === 'BS10' ||
          request.bpStateId === 'BS13'
        )
    },
    get removeExecutorAvailable () {
      return !isLastReportDeferred && (this.roleDispatcherOrHigher || isContractorDispatcher && !!request.actionsProps.contractorAssignmentAccess) &&
        (request.bpStateId === 'BS19' || request.bpStateId === 'BS21' || request.bpStateId === 'BS3' || request.bpStateId === 'BS4')
    },
    // ===
    get hasEditAccess () {
      const bpStateId = request.bpStateId
      return (this.roleDispatcherOrHigher && (bpStateId == 'BS0' || bpStateId == 'BS1' || bpStateId == 'BS2' || bpStateId == 'BS4' || bpStateId == 'BS8' || bpStateId == 'BS10' || bpStateId == 'BS13')) ||
          (this.roleExternalDispatcher && (bpStateId === 'BS0' || bpStateId === 'BS1' || bpStateId == 'BS9' || bpStateId == 'BS21')) ||
        (bpStateId == 'BS3' && (this.roleDispatcherOrHigher || this.roleExecutor)) ||
        (bpStateId !== 'BS0' && this.editAvailable)
    }
  }
  return requestRoles
}

export function loadRequestTypeConfiguration (requestTypeId, target) {
  if (requestTypeId) {
    if (target) {
      target.$q.loading.show({ spinnerColor: 'blue-11' })
    }
    return axiosGet({
      url: '/service/delta/request/getRequestTypeConfig?id=' + requestTypeId,
      onSuccess: (response) => {
        const configurationResult = response.data.result
        const configuration = {
          configurableFields: configurationResult.configurableFields,
          createRequestRole: configurationResult.createRequestRole,
          performeRequestRole: configurationResult.performeRequestRole,
          projectSelectionSource: configurationResult.projectSelectionSource,
          executableOnDeparture: !!configurationResult.executableOnDeparture,
          auditable: !!configurationResult.auditable,
          transmittable: !!configurationResult.transmittable,
          proposeExecutorsByWorkSchedule: !!configurationResult.proposeExecutorsByWorkSchedule,
          hasActualRequestInVis: !!configurationResult.hasActualRequestInVis,
          breakageTypes: configurationResult.breakageTypes || null
        }

        // return getPreparedRequestConfiguration(configuration)
        return configuration
      },
      onFailure: 'Ошибка получения конфигураций типа заявки'
    }).finally(() => {
      if (target) {
        target.$q.loading.hide()
      }
    })
  } else {
    return Promise.resolve({
      additionalFields: [], // TODO
      excludedFields: []

    })
  }
}

export function loadObjectActiveRequests (objectId, target, progress = true) {
  return loadObjectsActiveRequests([objectId], target, progress)
}

export function loadObjectsActiveRequests (objectsIds, target, progress = true) {
  if (target && progress) {
    target.$q.loading.show({ spinnerColor: 'blue-11' })
  }

  const urlParams = new URLSearchParams()
  if (objectsIds) {
    urlParams.set('objectId', objectsIds.join(','))
  }

  return axiosPost({
    url: '/service/delta/request/getObjectActiveRequests?' + urlParams.toString(),
    onSuccess: (response) => {
      return response.data
    },
    onFailure: 'Ошибка получения активных заявок'
  }).finally(() => {
    if (target && progress) {
      target.$q.loading.hide()
    }
  })
}

export async function getAdjacentObjectsRequests (objectId, requestId) {
  const requests = []

  const addUniqueRequests = (newRequests) => {
    newRequests.forEach(request => {
      if (!requests.some(r => r.id === request.id)) {
        requests.push(request)
      }
    })
  }

  if (Array.isArray(requestId)) {
    for (const rId of requestId) {
      const newRequests = await loadObjectsAdjacentRequests(objectId, rId)
      addUniqueRequests(newRequests)
    }
  } else {
    const newRequests = await loadObjectsAdjacentRequests(objectId, requestId)
    addUniqueRequests(newRequests)
  }
  return requests
}

export async function loadObjectsAdjacentRequests (objectId, requestId) {
  const bodyFormData = new FormData()
  if (objectId) {
    bodyFormData.set('objectId', objectId)
  }
  if (requestId) {
    bodyFormData.set('requestId', requestId)
  }

  return axiosPost({
    url: '/service/delta/serviceobject/getAdjacentObjectsRequests',
    data: bodyFormData,
    onSuccess: (response) => {
      const requests = response.data.result
      return requests
    },
    onFailure: (response) => {
      this.$q.notify({
        type: 'negative',
        message: response.message,
        progress: true,
        timeout: 8000
      })
    }
  })
}

export function loadRequestTypeProjects (requestTypeId, objectId, target) {
  if (target) {
    // target.$q.loading.show({ spinnerColor: 'blue-11' })
  }
  const url = `/service/delta/request/requestProjects?${requestTypeId ? 'requestTypeId=' + requestTypeId : ''}${objectId ? '&serviceObjectId=' + objectId : ''}`
  return axiosGet({
    url: url,
    onSuccess: (response) => {
      return response.data.result
    },
    onFailure: 'Ошибка получения проектов для выбранного типа заявки'
  }).finally(() => {
    if (target) {
      // target.$q.loading.hide()
    }
  })
}

/**
 * Фильтрация Проектов по доступу
 */
export function filterProjectsByUserAccess (projects, user, currentProjectId) {
  // const user = this.$store.getters.getUser
  const externalDispatcherBounded = user.hasRoleStrict('externalDispatcher') && !user.hasRole('dispatcher')

  let userAvailableProjectsIds = null
  if (externalDispatcherBounded) {
    if (user.employee && user.employee.availableProjects) {
      userAvailableProjectsIds = new Set(user.employee.availableProjects.map(o => o.id))
    }
  }
  if (userAvailableProjectsIds) {
    const filteredProjects = []
    for (const project of projects) {
      if (project.id === currentProjectId || userAvailableProjectsIds.has(project.id)) {
        filteredProjects.push(project)
      }
    }
    projects = filteredProjects
  }
  return projects
}

export function checkRequestTypeProject (requestTypeId, projectId, target) {
  if (target) {
    // target.$q.loading.show({ spinnerColor: 'blue-11' })
  }
  return axiosGet({
    url: '/service/delta/request/isRequestTypeProject?requestTypeId=' + requestTypeId + '&projectId=' + projectId,
    onSuccess: (response) => {
      return response.data.result
    },
    onFailure: 'Ошибка проверки проекта для выбранного типа заявки'
  }).finally(() => {
    if (target) {
      // target.$q.loading.hide()
    }
  })
}

export function computeCloseConditionTime (requestType, request, target) {
  let closeConditionTime = null

  if (requestType) {
    // округляем сверху до суток
    const internalCloseConditionTime = requestType.internalCloseConditionTime || 24 * 60 * 60 * 1000
    const currentDate = new Date()

    const closeCondition = new Date(internalCloseConditionTime + currentDate.getTime())
    closeCondition.setHours(0, 0, 0, 0)
    closeCondition.setDate(closeCondition.getDate() + 1)
    closeConditionTime = closeCondition.getTime()

    target.$q.notify({
      type: 'positive',
      message: 'Автоматическое вычисление срока выполнения заявки',
      progress: true,
      timeout: 3000
    })
  }

  Vue.set(request, 'closeConditionTime', closeConditionTime)
}

export function addConfigurableRequestProperties (request, requestConfiguration, user) {
  let configurationToSet = null
  if (requestConfiguration) {
    configurationToSet = getPreparedRequestConfiguration(requestConfiguration, user)
  } else if (!request._configuration) {
    configurationToSet = getPreparedRequestConfiguration(null, user)
  }
  // else {
  //   configurationToSet = getPreparedRequestConfiguration(request._configuration, user)
  // }
  addConfigurableObjectProperties(request)

  request.setRawConfiguration = function (configuration) {
    configuration = getPreparedRequestConfiguration(configuration, user)
    this.setConfiguration(configuration)
  }

  if (configurationToSet) {
    request.setConfiguration(configurationToSet)
  }
}

export function getPreparedRequestConfiguration (configuration, user) {
  if (!configuration) {
    configuration = {}
  }
  if (!configuration.configurableFields) {
    configuration.configurableFields = []
  }

  if (user) {
    const supervisor = user.restrictedAccess && user.hasRole('externalDispatcher')
    if (supervisor) {
      // const excludedFieldsKeys = ['closeConditionTime', 'priorityBlock', 'worksBlock', 'executorBlock']
      const excludedFieldsKeys = ['priorityBlock', 'worksBlock', 'executorBlock']

      for (const excludedFieldKey of excludedFieldsKeys) {
        configuration.configurableFields.push({
          key: excludedFieldKey,
          hidden: true
        })
      }
    }
  }

  configuration = getPreparedConfiguration(configuration, ADDITIONAL_FIELDS_CONFIGURATIONS)
  if (configuration.createRequestRole == null) {
    configuration.createRequestRole = []
  }
  if (configuration.performeRequestRole == null) {
    configuration.performeRequestRole = []
  }
  if (configuration.executableOnDeparture == null) {
    configuration.executableOnDeparture = true
  }
  if (configuration.auditable == null) {
    configuration.auditable = true
  }
  if (configuration.transmittable == null) {
    configuration.transmittable = true
  }
  if (configuration.proposeExecutorsByWorkSchedule == null) {
    configuration.proposeExecutorsByWorkSchedule = false
  }
  return configuration
}
